/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MeListGroupResponse } from "./MeListGroupResponse";

export type MeListGroupResponseApiRespoonse = {
  data?: MeListGroupResponse;
  status?: MeListGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MeListGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
